import {
  type BranchKey,
  configurationKeys,
  useInvalidateAllConciseBranches,
} from '@festina-life/api'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import {
  fetchAllBranchChangesetsKeyPrefix,
  fetchMetaModelKeyPrefix,
} from '../api/keys'

export const useInvalidateBranchAfterHistoryRewrite = () => {
  const queryClient = useQueryClient()
  const invalidateBranches = useInvalidateAllConciseBranches()
  return useCallback(
    (branchKey: BranchKey) => {
      void queryClient.removeQueries({
        queryKey: configurationKeys.fetchBranchAllErrorsPrefix({
          branchName: branchKey.name ?? '',
          server: branchKey.server,
        }),
      })

      void queryClient.removeQueries({
        queryKey: fetchAllBranchChangesetsKeyPrefix({
          branchName: branchKey.name,
          componentName: branchKey.server,
          isFromConfigurationServer: true,
        }),
      })

      void queryClient.removeQueries({
        queryKey: configurationKeys.fetchConciseBranchKeyPrefix({
          branchName: branchKey.name,
          server: branchKey.server,
        }),
      })

      void queryClient.removeQueries({
        queryKey: fetchMetaModelKeyPrefix({
          server: branchKey.server,
          branch: branchKey.name,
        }),
      })

      void invalidateBranches()
    },
    [invalidateBranches, queryClient],
  )
}
